import type { CSSProperties } from 'react';

import { useT } from '@/str';

const WEBVIEW_URL = 'https://play.google.com/store/apps/details?id=com.google.android.webview';

const screen: CSSProperties = {
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '16px',
  padding: '24px 16px',
  textAlign: 'center',
  background: '#141619',
  color: '#f2f3f5',
  fontFamily: 'system-ui, sans-serif',
};

const heading: CSSProperties = {
  margin: 0,
  maxWidth: '22ch',
  fontSize: '20px',
  fontWeight: 800,
  lineHeight: 1.25,
};

const note: CSSProperties = {
  margin: 0,
  maxWidth: '34ch',
  fontSize: '15px',
  lineHeight: 1.5,
  color: '#b4bcc4',
};

const action: CSSProperties = {
  marginTop: '8px',
  padding: '12px 20px',
  borderRadius: '8px',
  background: '#f5c518',
  color: '#141619',
  fontSize: '15px',
  fontWeight: 700,
  textDecoration: 'none',
};

export function Unsupported() {
  const t = useT();

  return (
    <div style={screen}>
      <h1 style={heading}>{t.unsupportedTitle}</h1>
      <p style={note}>{t.unsupportedBody}</p>
      <a style={action} href={WEBVIEW_URL} target="_blank" rel="noreferrer">
        {t.unsupportedAction}
      </a>
    </div>
  );
}
